import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AccountconfirmPage } from './accountconfirm';

@NgModule({
  declarations: [
    AccountconfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(AccountconfirmPage),
  ],
})
export class AccountconfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/accountconfirm/accountconfirm.module.ts